<template>
  <div class="layer">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
.layer
  position: relative
</style>
